import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ContentTitleImagePipe, HasTitleImagePipe, IPublishedOffer } from '@resident-nx/shared';
import { LabelWebComponent } from '../../atoms/label/label.component';
import { PictureWebComponent } from '../../atoms/picture/picture.component';

@Component({
  standalone: true,
  selector: 'rs-web-offers-card',
  templateUrl: './offers-card.component.html',
  styleUrls: ['./offers-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PictureWebComponent,
    LabelWebComponent,
    AsyncPipe,
    ContentTitleImagePipe,
    HasTitleImagePipe,
  ],
})
export class OffersCardWebComponent {
  @Input() item: IPublishedOffer;
}
